import {FC, ReactNode} from "react";
import {ILog} from "../../types/ApiTypes";
import {BsCheckCircle, BsExclamationCircle, BsExclamationTriangle, BsInfoCircle} from "react-icons/bs";

interface Props {
    item:ILog
}

const SpaceDetailsLogListItem: FC<Props> = (props) => {
    const iconClass = 'text-xl mr-2'
    let icon: ReactNode;
    if (props.item.status === "warning") {
        icon = <BsExclamationTriangle className={`${iconClass} text-orange-500`}/>
    } else if (props.item.status === "error") {
        icon = <BsExclamationCircle className={`${iconClass} text-error-brighter`}/>
    } else if (props.item.status === "info") {
        icon = <BsInfoCircle className={iconClass}/>
    } else {
        icon = <BsCheckCircle className={`${iconClass} text-success-darker`}/>
    }

    return (
        <li className='grid grid-cols-12 items-center'>
            {icon}
            <div className='flex flex-col col-span-11'>
                <span className='basis-1/4 text-accentGray text-xs'>{new Date(props.item.timestamp*1000).toLocaleString()}</span>
                <span className=''>{props.item.description}</span>
            </div>
        </li>
    );
};

export default SpaceDetailsLogListItem;